module.exports = __webpack_public_path__ + "img/CM-SL-CA-Infiniti-Modern.ce7f8e8f.jpeg";